import React, {useState} from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';

import axios from 'axios';
import {createTheme} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {ThemeProvider} from "@mui/material/styles";


let theme = createTheme();
theme = createTheme(theme, {
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  customError: {
    color: 'red',
    fontSize: '1rem',
    marginTop: 1
  },
  progress: {
    position: 'absolute'
  }
});

export default function Signup(props) {
  const navigate = useNavigate();
  const [appState, setAppState] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    country: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    errors: [],
    loading: false
  });

  const handleChange = (e) => {
    setAppState({
      ...appState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setAppState({
      ...appState,
      loading: true
    });
    const newUserData = {
      firstName: appState.firstName,
      lastName: appState.lastName,
      phoneNumber: appState.phoneNumber,
      country: appState.country,
      username: appState.username,
      email: appState.email,
      password: appState.password,
      confirmPassword: appState.confirmPassword
    };
    axios
      .post('/signup', newUserData)
      .then((response) => {
        localStorage.setItem('AuthToken', `${response.data.token}`);
        setAppState({
          ...appState,
          loading: false,
        });
        navigate("/home");
      })
      .catch((error) => {
        setAppState({
          ...appState,
          errors: error.response != null ? error.response.data : {"general": "Unexpected error occurred. Sorry for the inconvenience."},
          loading: false
        });
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline/>
        <div style={theme.paper}>
          <Avatar sx={theme.avatar}>
            <LockOutlinedIcon/>
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <form style={theme.form} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  name="firstName"
                  autoComplete="firstName"
                  helperText={appState.errors.firstName}
                  error={appState.errors.firstName ? true : false}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  autoComplete="lastName"
                  helperText={appState.errors.lastName}
                  error={appState.errors.lastName ? true : false}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="username"
                  label="User Name"
                  name="username"
                  autoComplete="username"
                  helperText={appState.errors.username}
                  error={appState.errors.username ? true : false}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  fullWidth
                  id="phoneNumber"
                  label="Phone Number"
                  name="phoneNumber"
                  autoComplete="phoneNumber"
                  pattern="[7-9]{1}[0-9]{9}"
                  helperText={appState.errors.phoneNumber}
                  error={appState.errors.phoneNumber ? true : false}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  helperText={appState.errors.email}
                  error={appState.errors.email ? true : false}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="country"
                  label="Country"
                  name="country"
                  autoComplete="country"
                  helperText={appState.errors.country}
                  error={appState.errors.country ? true : false}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  helperText={appState.errors.password}
                  error={appState.errors.password ? true : false}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                  id="confirmPassword"
                  autoComplete="current-password"
                  helperText={appState.errors.confirmPassword}
                  error={appState.errors.confirmPassword ? true : false}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={theme.submit}
              onClick={handleSubmit}
              disabled={appState.loading ||
                !appState.email ||
                !appState.password ||
                !appState.firstName ||
                !appState.lastName ||
                !appState.country ||
                !appState.username}
            >
              Sign Up
              {appState.loading && <CircularProgress size={30} sx={theme.progress}/>}
            </Button>
            <Grid container justify="flex-end">
              <Grid item>
                <Link href="login" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
            {/*{Object.values(appState.errors)[0] && (*/}
            {/*  <Typography variant="body2" sx={theme.customError}>*/}
            {/*    {Object.values(appState.errors)[0]}*/}
            {/*  </Typography>*/}
            {/*)}*/}
          </form>
        </div>
      </Container>
    </ThemeProvider>
  );
}